import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import CallHistoryMentors from './CallHistoryMentors';
import './MentorsProfileStyle.css';
import OverviewMentors from './OverviewMentors';
import ViewSlots from './ViewSlots';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import AddSlotPopup from '../../../components/Popups/AddSlotPopup/AddSlotPopup';
import CallSchedule from '../../../components/Popups/CallSchedule/CallSchedule';
import Congratulations from '../../../components/Popups/Congratulations/Congratulations';
import { addMentorAvailableSlots, adminData, clearData, clearSlots, clearState, getFeedbackAnswers, getMentorAvailableDates, getMentorCallsActivity, getMentorPerformance, getMentorSlotsByDate, getParticularUser, getPastInterviewDetails, getUpcomingInterviewDetails } from '../../../reducer/adminSlice';
import { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import AdviewCallhistory from '../../../components/Popups/ViewCallDetails/AdviewCallhistory';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import Skeleton from 'react-loading-skeleton';

function MentorsProfile() {

    //Add Slot Templates
    const now = new Date(moment().hour(0).minute(0).second((0)));
    const format = "h:mm a";
    const daysInAWeek = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];

    const timeRangeCountTemplate = {
        mon: [0],
        tue: [0],
        wed: [0],
        thur: [0],
        fri: [0],
        sat: [0],
        sun: [0],
    };

    const interviewTimeTemplate = {
        sun: [{ from: now, to: now }],
        mon: [{ from: now, to: now }],
        tue: [{ from: now, to: now }],
        wed: [{ from: now, to: now }],
        thur: [{ from: now, to: now }],
        fri: [{ from: now, to: now }],
        sat: [{ from: now, to: now }]
    };

    //Filter templates
    const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const months = [moment().month(), moment().add(1,"months").month(), moment().add(2,"months").month(), moment().add(3,"months").month(), moment().add(4,"months").month(), moment().add(5,"months").month(), moment().add(6,"months").month(), moment().add(7,"months").month(), moment().add(8,"months").month(), moment().add(9,"months").month(), moment().add(10,"months").month(), moment().add(11,"months").month()];

    const [isUpcomingCalls, setIsUpcomingCalls] = useState(true);
    const [selectedDate, setSelectedDate] = useState("");
    const [tabActive, setTabActive] = useState(1);
    const [addSlotPopupToggler, setAddSlotPopupToggler] = useState(false);

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalUpcomingCalls, setTotalUpcomingcalls] = useState([]);
    const [totalPastCalls, setTotalPastCalls] = useState([]);

    //Search states
    const [search, setSearch] = useState("");

    //Filter states
    const [program, setProgram] = useState("");
    const [date, setDate] = useState("");
    const [status, setStatus] = useState("");

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    //Add Slots States
    const [dateRange, setDateRange] = useState({
        from: "",
        to: ""
    });
    const [selectedWeekDays, setSelectedWeekDays] = useState([]);

    const [timeRangeCount, setTimeRangeCount] = useState(timeRangeCountTemplate);
    const [interviewTime, setInterviewTime] = useState(interviewTimeTemplate);

    //Get slot states
    const [selectedMonth, setSelectedMonth] = useState("");

    //View call details states
    const [viewCallDetails, setViewCallDetails ] = useState(false);
    const [menteeFeedback, setMenteeFeedback] = useState({});
    const [mentorFeedback, setMentorFeedback] = useState({});

    const { isLoaderFetching, isCallsFetching, userDataFetching, isUserDashboardFetching, isSlotsFetching, isSlotDatesFetching, isSuccess, isError, errorMessage, particularUser, userUpcomingCalls, userPastCalls, mentorSlotDates, mentorSlots, feedback, mentorPerformance, mentorCallsData } = useSelector(adminData);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userId } = useParams();

    //Get Months difference
    const getDiff = (param) => {
        return (moment(param).fromNow());
    };

    //Get slot Functions
    const handleSelectDate = (date) => {
        setSelectedDate(date);
    };

    //Add Slot Functions
    const handleAddSlotsChange = (e) => {
        if(e) {
            setDateRange({
                from: e[0],
                to: e[1]
            })
        }
    }

    const handleCheckboxToggle = (day) => {
        if (selectedWeekDays.includes(day)) setSelectedWeekDays(prev => prev.filter(item => item !== day))
        else setSelectedWeekDays(prev => [...prev, day]);
    };

    const handleTimeFromChange = (e, type, i) => {
        const value = e;
        const timeSlot = interviewTime[type];
        timeSlot[i].from = value;
        setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlot] }));
    };

    const handleTimeToChange = (e, type, i) => {
        const value = e;
        const timeSlot = interviewTime[type];
        timeSlot[i].to = value;
        setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlot] }));
    };

    const handleTimeSlotRemove = (type, index) => {
        if (interviewTime[type].length === 1) {
            setSelectedWeekDays(prev => prev.filter(day => day !== type));
        }
        else {
            const timeSlots = interviewTime[type];
            const timeSlot = timeRangeCount[type];
            timeSlot.splice(index, 1);
            timeSlots.splice(index, 1);
            setTimeRangeCount((prev) => ({ ...prev, [type]: [...timeSlot] }));
            setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlots] }));
        }
    };

    const validate = () => {
        if (dateRange.from === "" || dateRange.to === "") return "date";
        if (selectedWeekDays.length === 0) return "noSlot";
        let check = "";
        selectedWeekDays.forEach((day) => {
            if(day === "sun") return;
            interviewTime[day].forEach((time) => {
                if( (moment(time.from).format("HH") < 10 || moment(time.to).format("HH") < 10)  || (moment(time.from).format("HH") > 22 || moment(time.to).format("HH") > 22)) {
                    check = "new";
                }
                if ((new Date(time.from).getTime() + 1200000) > new Date(time.to).getTime()) {
                    check = "time";
                };
            })
        })
        return check;
    };

    const handleAddSlots = () => {
        if (validate()) {
            if (validate() === "date") {
                setIsShowError(true);
                setErrMessage("Please select a date range!");
            }
            if (validate() === "time") {
                setIsShowError(true);
                setErrMessage("Time slots should have atleast 20 min difference!")
            }
            if (validate() === "noSlot") {
                setIsShowError(true);
                setErrMessage("Please select a day for availablity!")
            }
        }
        else {

            let obj;
            obj = interviewTime;
            for (const day in interviewTime) {
                if (!selectedWeekDays.includes(day)) {
                    // delete obj[day];
                    obj = { ...obj, [day]: [] }
                }
                else {
                    const din = obj[day];
                    din.map((time) => {
                        time.from = moment(time.from).format("HH:mm:ss");
                        time.to = moment(time.to).format("HH:mm:ss")
                    });
                    obj = { ...obj, [day]: [...din] }
                }
            }
            const object = {
                mentorId: userId,
                programId: particularUser?.programId,
                dateRange: dateRange,
                interviewTime: obj
            }
            dispatch(addMentorAvailableSlots(object));
            setTimeRangeCount(timeRangeCountTemplate);
            setInterviewTime(interviewTimeTemplate);
        }

    };

    const handleAddSlotsClose = () => {
        setSelectedWeekDays("");
        setDateRange({
            from: "",
            to: ""
        })
        setAddSlotPopupToggler(false);
        setTimeRangeCount(timeRangeCountTemplate);
        setInterviewTime(interviewTimeTemplate);
    };

    const handleAddSlotsDiscard = () => {
        setSelectedWeekDays("");
        setTimeRangeCount(timeRangeCountTemplate);
        setInterviewTime(interviewTimeTemplate);
    };

    //View Call details Functions
    const handleViewCallDetails = (id) => {
        setViewCallDetails(true);
        dispatch(getFeedbackAnswers(id));
    };

    const handleViewCallClose = () => {
        setViewCallDetails(false);
        setMenteeFeedback({});
        setMentorFeedback({});
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentor", userId, search, date, index: index+1}))
        else dispatch(getPastInterviewDetails({user: "mentor", userId, search, date, status, index: index+1}));
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setIndex(1);
            if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentor", userId, search, status}))
            else dispatch(getPastInterviewDetails({user: "mentor", userId, search, status}));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setIndex(1);
            if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentor", userId, search, status}))
            else dispatch(getPastInterviewDetails({user: "mentor", userId, search, status}));
        }
    };

    //Filter functions
    const handleStatusFilter = (status) => {
        setTotalUpcomingcalls([]);
        setTotalPastCalls([]);
        setIndex(1);
        if(isUpcomingCalls) dispatch(getUpcomingInterviewDetails({user: "mentor", userId, status}))
        else dispatch(getPastInterviewDetails({user: "mentor", userId, status}));
    }

    const handleDateFilter = (e) => {
        const { value } = e.target;
        dispatch(clearSlots());
        setSelectedMonth(value);
        setSelectedDate("");
        const year = moment().year();
        const month = monthNames[value];
        const date =  moment(`${year}-${month}-01`).format("YYYY-MM-DD");
        if(monthNames[moment().month()] === month) dispatch(getMentorAvailableDates({userId}))
        else dispatch(getMentorAvailableDates({userId, date}));
    };

    //Initial useEffect
    useEffect(() => {
        dispatch(getParticularUser({user: "mentor", userId}));
        dispatch(getMentorCallsActivity(userId));
        dispatch(getMentorPerformance(userId));

        return () => {
            dispatch(clearSlots());
            dispatch(clearData());
        }
    },[]);

    //Load more useEffect
    useEffect(() => {
        if(index === 1 && userUpcomingCalls?.calls?.length > 0 ) setTotalUpcomingcalls(userUpcomingCalls?.calls);
        if(index === 1 && userPastCalls?.calls?.length > 0) setTotalPastCalls(userPastCalls?.calls);
        if(index !== 1 && userUpcomingCalls?.calls?.length > 0 ) setTotalUpcomingcalls(prev => [...prev,...userUpcomingCalls?.calls]);
        if(index !== 1 && userPastCalls?.calls?.length > 0) setTotalPastCalls(prev => [...prev,...userPastCalls?.calls]);
    },[userUpcomingCalls,userPastCalls]);

    //Tab toggler useEffect
    useEffect(() => {
        setSelectedDate("");
        setSelectedMonth(months[0]);
        dispatch(clearSlots());
        setTotalPastCalls([]);
        setTotalUpcomingcalls([]);
        setIndex(1);
        if(tabActive === 3 && isUpcomingCalls) {
            dispatch(getUpcomingInterviewDetails({user: "mentor", userId}));
        }
        if(tabActive === 3 && !isUpcomingCalls) {
            dispatch(getPastInterviewDetails({user: "mentor", userId}));
        }
        if(tabActive === 4) dispatch(getMentorAvailableDates({userId, selectedDate}));
        // if(tabActive === 4) dispatch(getParticularUser({user: "mentor", userId}));
    },[tabActive, isUpcomingCalls]);

    //View slot useEfect
    useEffect(() => {
        if(selectedDate) {
            dispatch(getMentorSlotsByDate({userId, date: selectedDate, programId: particularUser?.programId}));
            dispatch(clearSlots());
        }
    },[selectedDate])

    //AddSlot useEffect
    useEffect(() => {
        const InBetweenDays = Math.abs((new Date(dateRange.from).getTime() - new Date(dateRange.to).getTime()) / (1000 * 60 * 60 * 24));
        if (dateRange.to !== "") {
            if (InBetweenDays <= 6) {
                setSelectedWeekDays([]);
                for (let i = 0; i <= InBetweenDays; i++) {
                    if (i > 6) break;
                    const day = new Date(moment(dateRange.from).add(i, "day")).getDay();
                    setSelectedWeekDays(prev => [...prev, daysInAWeek[day]]);
                }
            }
            else {
                setSelectedWeekDays(daysInAWeek.filter(item => item !== "sun"));
            }
        }
    }, [dateRange]);

    //View call details useEffect
    useEffect(() => {
        if(feedback?.feedbackAnswers?.length > 0) {
            const menteeArr = feedback?.feedbackAnswers?.filter((item) => item.menteeId);
            const mentorArr = feedback?.feedbackAnswers?.filter((item) => item.mentorId);
            setMenteeFeedback(...menteeArr);
            setMentorFeedback(...mentorArr);
        }
    },[feedback])

    //Success useEffect
    useEffect(() => {
        if(isSuccess) {
            setIsShowSuccess(true);
            setSuccessMessage("Success");
            setTabActive(2);
            setAddSlotPopupToggler(false);
            setDateRange({
                from: "",
                to: ""
            })
            dispatch(getParticularUser({user: "mentor", userId}));
            dispatch(clearState());
            dispatch(clearSlots());
        }
    },[isSuccess]);

    return (
        <>
        <section>
        {isLoaderFetching && <PageLoader />}
            <AddSlotPopup isActive={addSlotPopupToggler} dateRange={Object.values(dateRange)} setIsActive={setAddSlotPopupToggler} onChange={handleAddSlotsChange} now={now} format={format} daysInAWeek={daysInAWeek} selectedWeekDays={selectedWeekDays} interviewTime={interviewTime} setInterviewTime={setInterviewTime} timeRangeCount={timeRangeCount} setTimeRangeCount={setTimeRangeCount} handleCheckboxToggle={handleCheckboxToggle} handleTimeFromChange={handleTimeFromChange} handleTimeToChange={handleTimeToChange} handleTimeSlotRemove={handleTimeSlotRemove} handleSave={handleAddSlots} handleDiscard={handleAddSlotsDiscard} handleClose={handleAddSlotsClose} />
            <AdviewCallhistory isActive={viewCallDetails} feedbackof={"mentee"} setIsActive={setViewCallDetails} menteeFeedback={menteeFeedback} mentorFeedback={mentorFeedback} callInfo={feedback} handleClose={handleViewCallClose} />
            <CallSchedule />
            <Congratulations maintext={'Congratulations!'} textpass={'The slots have successfully been added.'} />

            <div className="DashboardWrapper">
                <div className='pathlinkwrapper flex gap-10'>
                    <img src='assets/img/usericons.png' alt="" />
                    <p className='text2' onClick={()=> navigate('/admin/all-mentor')}>All Mentors</p>
                    <img src="/assets/img/arrowright.png" alt="" />
                    <p className='text2'>Mentor Profile</p>
                </div>

                <div className="headingprofilewrap mt-30">
                    <h2 className='heading-2'>Profile Overview</h2>
                    {userDataFetching ? <Skeleton width={"150px"} /> : <p className='text3 mt-5'>Joined {getDiff(particularUser?.createdAt)}</p>}
                </div>

                <div className="flex-col Allcardboxwrapper mt-30">
                    <div className="profilewrapper w-100 ">
                        <div className="flex Adprofiledatawrapper">
                            {userDataFetching ? <Skeleton width={"160px"} height={"160px"} /> : <div className='Imageboxall'>
                                <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                            </div>}
                            <div className="AdProfileDetailsarea">
                                <div className="headingwrap">
                                    <div className="headingorg flex gap-10">
                                        <h2 className='heading-2'>{userDataFetching ? <Skeleton width={"200px"} /> : particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                        {particularUser?.linkedin && <a href={particularUser?.linkedin.slice(0,4) === "http" ? particularUser?.linkedin : "https://" + particularUser?.linkedin} className='linkedintext' target='_blank' rel='noreferrer'>
                                            <span className='flex gap-2'>
                                                Linkedin
                                                <img src="/assets/img/send.png" alt="" />
                                            </span>
                                        </a>}
                                    </div>
                                    <div className="AdPsnlDetailsMentors mt-10">
                                        {userDataFetching ? <Skeleton width={"200px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/usermentor.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.profession?.designation ? particularUser?.profession?.designation : "---"}, {particularUser?.profession?.company ? particularUser?.profession?.company : "---"}</p>
                                        </div>}
                                        {userDataFetching ? <Skeleton width={"130px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/emailprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                        </div>}
                                        {userDataFetching ? <Skeleton width={"100px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/callprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.mobileNumber ? particularUser?.mobileNumber : "---"}</p>
                                        </div>}
                                    </div>
                                </div>
                                <div className="AdCardsProfilWrapper flex gap-10 mt-40">
                                    {userDataFetching ?
                                    <div className={`CardContactWrapper`}>
                                    <span className='Adicontoolsicons flex-center'>
                                        {<Skeleton width={"50px"} height={"50px"} circle />}
                                    </span>
                                    <div className="contentareacontact">
                                        <span>{<Skeleton width={"30px"} height={"20px"} />}</span>
                                        <Skeleton width={"100px"} height={"15px"} />
                                    </div>
                                </div>
                                :
                                <ProfileCard number={particularUser?.noOfCalls ?? 0} text={'Delivered Solutions'} img={"/assets/img/yellowcall.png"} />}
                                    {/* <ProfileCard className={'purpleCard'} number={'32'} text={'Number of Hours'} img={"/assets/img/iconsalarm.png"} /> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="AdMenusTabWrapper w-100 mt-40 mnAdlistmenufix">
                        <ul className='flex gap-30 items-center'>
                            <li onClick={() => setTabActive(1)} className={tabActive === 1 && 'active'}>Overview</li>
                            <li onClick={() => setTabActive(2)} className={tabActive === 2 && 'active'}>Profile Details</li>
                            <li onClick={() => setTabActive(3)} className={tabActive === 3 && 'active'}>Call History</li>
                            <li onClick={() => setTabActive(4)} className={tabActive === 4 && 'active'}>View Slots</li>
                        </ul>
                    </div>

                </div>

            </div>

            <OverviewMentors isActiveTab={tabActive === 1 && 'active'} callsData={mentorCallsData} performanceData={mentorPerformance} isFetching={isUserDashboardFetching} />
            <Profiledetails isActiveTab={tabActive === 2 && 'active'} data={particularUser} isFetching={userDataFetching} />
            <CallHistoryMentors isActiveTab={tabActive === 3 && 'active'} handleSearch={handleSearch} handleSearchPress={handleSearchPress} handleSearchChange={handleSearchChange} handleStatusFilter={handleStatusFilter} isUpcomingCalls={isUpcomingCalls} setIsUpcomingCalls={setIsUpcomingCalls} upcomingCalls={totalUpcomingCalls} pastCalls={totalPastCalls} upcoming={userUpcomingCalls} past={userPastCalls} onClickViewCallDetails={handleViewCallDetails} handleLoadMore={handleLoadMore} isFetching={isCallsFetching} />
            <ViewSlots isActiveTab={tabActive === 4 && 'active'} isSlotDatesFetching={isSlotDatesFetching} isSlotsFetching={isSlotsFetching} selectedMonth={selectedMonth} selectedDate={selectedDate} setIsActive={setAddSlotPopupToggler} mentorSlotDates={mentorSlotDates} slots={mentorSlots} handleSelectDate={handleSelectDate} setAddSlotPopupToggler={setAddSlotPopupToggler} monthNames={monthNames} months={months} handleDateFilter={handleDateFilter} />

        </section>
        </>
    )
}

export default MentorsProfile